import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { CorpProjectRequest, Project } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { NgIf, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";

@Component({
    selector: 'app-project-details',
    templateUrl: './project-details.component.html',
    styleUrls: ['./project-details.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatRadioGroup, MatRadioButton, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions]
})
export class ProjectDetailsComponent implements OnInit {
    manageCompanyContent: any;
  displayedColumns: string[] = ['Project Name', 'Project Code', 'Status', 'Actions']
  prjectDetailsForm: FormGroup | any;
  tableData: Project[] = [];
  Addnew: boolean = false;
  isLoading = true;

  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;
  private destroy$ = new Subject<void>();
  content:any;
  dictionaryContent:any;
  constructor(private readonly bookingContentService: BookingContentService, private _camService: CamService, private fb: FormBuilder, private dialog: MatDialog, private _ToastrApiService: ToastrApiService, public _CommonService: CommonService, private _CompanyManagementService: CompanyManagementService,private contentService:CompanyManagementContentService, private readonly dictionaryContentServcie:DisctionaryContent) {

    this.prjectDetailsForm = this.fb.group({
      flag: ['ADD'],
      corpProjectID: [null],
      projectName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      projectCode: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(20)]],
      status: [true, [Validators.required]]

    })

  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
    this.dictionaryContentServcie.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dictionaryContent = res;
    });
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.getProjectDetailsList()
      this.contentService.content$.subscribe((res: any) => { this.manageCompanyContent = res; });

  }
  handleEvent(event: string) {
    if (event.includes('project-details')) {
      this.Addnew = true;
    }
  }

  getProjectDetailsList() {
    this.isLoading = true
    this._camService.getProjectDetails(0).then((res: ApiResponse<Project[]>) => {

      if (res.status == 'Success') {
        this.tableData = res.data;
      }
    }).catch((error) => {
      const errMsg = error?.message || error?.error?.message || 'Something went wrong while fetching project details.';
      // this._ToastrApiService.show('error', errMsg)
      this.tableData = [];
      console.error(error)
    }).finally(() => {
      this.isLoading = false
    })
  }

  addNewCostCenter() {
    this.Addnew = true
    this.prjectDetailsForm.reset({
      flag: 'ADD',
      corpProjectID: null,
      projectName: '',
      projectCode: '',
      status: true
    })

    this._CompanyManagementService.company_management_projectDetail('Add link','Add', this.tableData.length)// GTM use
  }

  onCancel() {
    this.Addnew = false
    this._CompanyManagementService.company_management_projectDetail('Cancel button','Cancel', this.tableData.length)// GTM use

  }

  onSave() {
    this._CompanyManagementService.company_management_projectDetail('Save button','Save', this.tableData.length)// GTM use
    
    if (this.prjectDetailsForm.invalid) {
      return
    }

    const requestData: CorpProjectRequest = {
      flag: this.prjectDetailsForm.value.flag,
      corpProjectID: this.prjectDetailsForm.value.corpProjectID,
      projectName: this.prjectDetailsForm.value.projectName,
      projectCode: this.prjectDetailsForm.value.projectCode,
      status: this.prjectDetailsForm.value.status
    }

    this._camService.insertUpdateProjectDetailsV1(requestData).then((res) => {

      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }

      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Project details created successfully.');
          this._CompanyManagementService.save_success('Project details', 'Success')//GTM use
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || 'Project details updated successfully.');
          this._CompanyManagementService.save_success('Project details', 'Success')//GTM use
          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Duplicate entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          console.warn('Unhandled status:', res);
          break;
      }


      //Refresh the page
      this.getProjectDetailsList()
      this.Addnew = false
      this._CommonService.formResetTrigger();
      this.prjectDetailsForm.reset({
        flag: 'ADD',
        corpProjectID: null,
        projectName: '',
        projectCode: '',
        status: true

      })



    }).catch((error: any) => {
      console.error(error)
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the Project details. Please try again later.';
      this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage)
    })

  }

  onEdit(item: Project) {
    this._CompanyManagementService.company_management_projectDetail('Edit button','Edit', this.tableData.length)// GTM use

    this.Addnew = true
    this.prjectDetailsForm.patchValue({
      flag: 'UPDATE',
      corpProjectID: item.corpProjectId,
      projectName: item.projectName,
      projectCode: item.projectCode,
      status: item.status,

    })
  }

  onRemove(item: Project) {
    this._CompanyManagementService.company_management_projectDetail('Remove button','Remove', this.tableData.length)// GTM use

    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, // Pass the item data
    });

  }

  confirmDelete(item: Project) {

    const request: CamDeleteModel = {
      id: item.corpProjectId,
      type: 'PROJECT'
    }

    this._camService.DeleteCAMitemBytype(request).then((res) => {
      if (res.status == "Success") {
        this._ToastrApiService.show('success', res.message);
        this._CompanyManagementService.project_remove_Successfully('Confirm','Success')// GTM use
        this.currentItem = undefined;
        this.getProjectDetailsList()
        this.Addnew = false
      }
    }).catch((error) => {
      console.error(error)
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while delete the project detail. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    });
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._CompanyManagementService.projectDetail_remove('Proceed', 'Are you sure you want to remove this project?')//GTM use
    }

    if (!result){
      this._CompanyManagementService.projectDetail_remove('Cancel', 'Are you sure you want to remove this project?')//GTM use

    }

    this.dialog.closeAll(); // Closes the dialog
  }


  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }

  sitecoreGetWarningMessage(messageId: string): any {
    return this.content?.warningList?.find(
      (item: any) => item.messageID === messageId
    );
  }

}






